module.exports = __webpack_public_path__ + "static/media/late.7b006451.svg";